(function () {
  const root = document.getElementById('mhode-cart');
  if (!root) return;

  const threshold = parseInt(root.dataset.threshold || '4000', 10);
  const moneyFormat = root.dataset.moneyFormat || '£{{amount}}';
  const upsellVariantId = root.dataset.upsellVariant || '';

  const linesEl = root.querySelector('[data-mhode-lines]');
  const emptyEl = root.querySelector('[data-mhode-empty]');
  const countEl = root.querySelector('[data-mhode-count]');
  const subEl = root.querySelector('[data-mhode-subtotal]');
  const shipEl = root.querySelector('[data-mhode-shipping]');
  const shipTextEl = root.querySelector('[data-mhode-shipping-text]');
  const shipFillEl = root.querySelector('[data-mhode-shipping-fill]');
  const upsellEl = root.querySelector('[data-mhode-upsell]');

  function money(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, (cents/100).toFixed(0));
  }

  function closeThemeCartDrawer() {
    const themeCartDrawer = document.querySelector('cart-drawer-component');
    const themeCartDialog = themeCartDrawer && themeCartDrawer.querySelector('dialog[open]');

    if (!themeCartDialog) return;

    if (typeof themeCartDrawer.close === 'function') {
      themeCartDrawer.close();
    } else if (typeof themeCartDialog.close === 'function') {
      themeCartDialog.close();
    }
  }

  function open() {
    closeThemeCartDrawer();
    root.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function close() { root.setAttribute('hidden', ''); document.body.style.overflow = ''; }

  async function updateQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      await refresh();
    } catch (err) { console.error('[mhode-cart] update failed', err); }
  }

  async function addById(id) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
      });
      await refresh();
    } catch (err) { console.error('[mhode-cart] add by id failed', err); }
  }

  function buildLine(item) {
    const wrap = document.createElement('article');
    wrap.className = 'mhode-cart__line';
    const img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1$2') : '';
    const variant = (item.options_with_values || []).map(o => o.value).join(' · ');
    const variantText = variant && variant !== 'Default Title' ? variant : '';
    const sellingPlan =
  item.selling_plan_allocation &&
  item.selling_plan_allocation.selling_plan
    ? item.selling_plan_allocation.selling_plan.name
    : '';
    const safe = (s) => (s || '').replace(/"/g, '&quot;');
    wrap.innerHTML =
      '<a class="mhode-cart__line-img" href="' + safe(item.url) + '"><img src="' + img + '" alt="' + safe(item.product_title) + '" width="80" height="80" loading="lazy" decoding="async"></a>' +
      '<div class="mhode-cart__line-body">' +
      '<a class="mhode-cart__line-title" href="' + safe(item.url) + '">' + (item.product_title || '') + '</a>' +
      '<p class="mhode-cart__line-variant">' + variantText + '</p>' +
      (sellingPlan
        ? '<p class="mhode-cart__line-selling-plan">' + sellingPlan + '</p>'
        : '') +
      '<div class="mhode-cart__line-controls">' +
      '<div class="mhode-cart__qty"><button type="button" data-step="-1" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-step="1" aria-label="Increase">+</button></div>' +
      '<button type="button" class="mhode-cart__remove" data-remove aria-label="Remove">Remove</button>' +
      '</div></div>' +
      '<p class="mhode-cart__line-price">' + money(item.final_line_price) + '</p>';
    wrap.querySelectorAll('[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => updateQty(item.key, Math.max(0, item.quantity + parseInt(btn.dataset.step, 10))));
    });
    wrap.querySelector('[data-remove]').addEventListener('click', () => updateQty(item.key, 0));
    return wrap;
  }

  function render(cart) {
    countEl.textContent = '(' + cart.item_count + ')';
    subEl.textContent = money(cart.total_price);

    linesEl.querySelectorAll('.mhode-cart__line').forEach((el) => el.remove());
    if (cart.items.length === 0) {
      emptyEl.removeAttribute('hidden');
    } else {
      emptyEl.setAttribute('hidden', '');
      cart.items.forEach((item) => linesEl.appendChild(buildLine(item)));
    }

    const remaining = threshold - cart.total_price;
    if (remaining <= 0) {
      shipEl.classList.add('is-complete');
      shipTextEl.textContent = 'You’ve unlocked free UK shipping';
      shipFillEl.style.width = '100%';
    } else {
      shipEl.classList.remove('is-complete');
      shipTextEl.textContent = 'Add ' + money(remaining) + ' more for free UK shipping';
      shipFillEl.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }

    if (upsellEl) {
      const cartIds = cart.items.map((i) => String(i.variant_id));
      const inCart = upsellVariantId && cartIds.indexOf(upsellVariantId) !== -1;
      if (cart.items.length === 0 || inCart) upsellEl.setAttribute('hidden', '');
      else upsellEl.removeAttribute('hidden');
    }
  }
  function dispatchCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('mhode:cart:updated', { detail: cart }));

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'mhode-cart',
        data: {
          itemCount: cart.item_count,
          source: 'mhode-cart',
        },
      },
    }));
  }

  async function refresh() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      render(cart);
      dispatchCartUpdated(cart);
    } catch (err) { console.error('[mhode-cart] refresh failed', err); }
  }

  // Bind events
  root.querySelectorAll('[data-mhode-close]').forEach((el) => el.addEventListener('click', close));
  const addUpsellBtn = root.querySelector('[data-mhode-add-upsell]');
  if (addUpsellBtn && upsellVariantId) {
    addUpsellBtn.addEventListener('click', () => addById(upsellVariantId));
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
  });

  // Intercept all add-to-cart form submits
  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-mhode-skip')) return;
    e.preventDefault();
    const data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    }).then((r) => {
      if (!r.ok) throw new Error('Add failed');
      refresh().then(open);
    }).catch((err) => { console.error('[mhode-cart] form submit failed', err); form.submit(); });
  }, true);

  // Cart icon clicks → open drawer
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest && e.target.closest(
      'a[href$="/cart"], [data-mhode-cart-open], cart-drawer-component [data-testid="cart-drawer-trigger"]'
    );
    if (!trigger || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // Initial state
  refresh();

  // Expose for other scripts
  window.MhodeCart = { open: open, close: close, refresh: refresh };
})();
